const axios = require("axios").default;

const URL = `${process.env.REACT_APP_API_URL}/invoice`;
const URL_CUSTOMER = `${process.env.REACT_APP_API_URL}/customer`;
const URL_Client = `${process.env.REACT_APP_API_URL}/client`;
const URL_MATERIAL = `${process.env.REACT_APP_API_URL}/materialbatch`;
const URL_MATERIAL_OLD = `${process.env.REACT_APP_API_URL}/material-old`;
const URL_PARAM = `${process.env.REACT_APP_API_URL}/param`;
const URL_RETURN = `${process.env.REACT_APP_API_URL}/return`;
const URL_USER = `${process.env.REACT_APP_API_URL}/user/me`;

export const getAll = (payload) => {
  return axios.get(URL, {
    params: payload,
  });
};

export const postRtv = (payload) => {
  return axios.post(URL_RETURN, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const getCustomer = (payload) => {
  return axios.get(URL_CUSTOMER, {
    params: payload,
  });
};

export const getClient = (payload) => {
  return axios.get(URL_Client, {
    params: payload,
  });
};

export const getMaterial = (payload) => {
  return axios.get(URL_MATERIAL, {
    params: payload,
  });
};

export const getMaterialOld = (payload) => {
  return axios
    .get(URL_MATERIAL_OLD, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const getParam = (payload) => {
  return axios.get(URL_PARAM, {
    params: payload,
  });
};

export const getUser = (payload) => {
  return axios.get(URL_USER, {
    params: payload,
  });
};

export const postFile = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return axios.post(`${URL_RETURN}/attachment`, formData);
};

export const updatePostRtv = (payload, id) => {
  return axios.put(`${URL_RETURN}/${id}`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const updateItem = (payload, id) => {
  return axios.put(`${URL_RETURN}/${id}`, payload);
};
